export { default } from "./TruncatedFolderPath";
